import { type CrudFilter } from 'admin';
import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

export const useSyncFormFieldsWithFilters = <T extends Record<string, string>>(
  form: UseFormReturn<T>,
  setFilters: (filters: CrudFilter[]) => void
) => {
  useEffect(() => {
    const subscription = form.watch((values) => {
      const filters: CrudFilter[] = [];
      Object.entries(values).forEach(([key, value]) => {
        if (value) {
          filters.push({
            field: key,
            operator: 'eq',
            value,
          });
        }
      });
      setFilters(filters);
    });
    return () => subscription.unsubscribe();
  }, [form, setFilters]);
};
